import { render, staticRenderFns } from "./paymentRecordDetail.vue?vue&type=template&id=abac23d2&scoped=true&"
import script from "./paymentRecordDetail.vue?vue&type=script&lang=js&"
export * from "./paymentRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./paymentRecordDetail.vue?vue&type=style&index=0&id=abac23d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abac23d2",
  null
  
)

export default component.exports